<template>
  <div class="search-row">
    <el-select ref="categorySelect" :value="category" placeholder="类别" class="category-select" @change="$emit('update:category', $event)" @visible-change="handleCategoryVisibleChange">
      <el-option v-for="item in myProductTypeList" :key="item.productTypeId + ''" :label="item.typeName" :value="item.productTypeId + ''"></el-option>
    </el-select>
    <div class="divider"></div>
    <el-input :value="keyword" placeholder="输入产品名称，如：不锈钢板材" class="search-input" clearable @input="$emit('update:keyword', $event)">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <slot name="action"></slot>
  </div>
</template>

<script>
import { getDictData } from "@/api";
import { getMyProductType } from "@/api/demand";

export default {
  name: "SearchBar",
  props: {
    category: {
      type: String,
      default: "",
    },
    keyword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      productTypes: [],
      myProductTypeList: [],
    };
  },
  created() {
    // this.fetchProductTypes();
    this.getMyProductTypeFun();
  },
  methods: {
    getMyProductTypeFun() {
      getMyProductType().then((res) => {
        this.myProductTypeList = res.rows;
      });
    },

    fetchProductTypes() {
      getDictData("app_product_type").then((res) => {
        this.productTypes = (res.data || []).map((item) => ({
          label: item.dictLabel,
          value: item.dictValue,
        }));
      });
    },

    handleCategoryVisibleChange(visible) {
      if (visible) {
        this.$emit("category-open");
      }
    },
  },
};
</script>

<style scoped>
.search-row {
  display: flex;
  align-items: center;
  height: 52px;
}

.category-select {
  width: 130px;
  flex-shrink: 0;
}

.category-select >>> .el-input__inner {
  height: 52px;
  line-height: 52px;
  border-radius: 4px 0 0 4px;
  padding-left: 12px;
  padding-right: 20px;
  font-size: 16px;
}

.divider {
  width: 1px;
  height: 20px;
  background-color: #dcdfe6;
  margin-left: -1px;
  z-index: 1;
  position: relative;
}

.search-input {
  flex: 1;
  margin-left: -1px;
  font-size: 16px;
}

.search-input >>> .el-input__inner {
  height: 52px;
  line-height: 52px;
  border-radius: 0 4px 4px 0;
  border-left: none;
  padding-left: 35px;
}

.search-row:focus-within .category-select >>> .el-input__inner {
  border-color: #409eff;
}

.search-row:focus-within .search-input >>> .el-input__inner {
  border-color: #409eff;
}

.search-input >>> .el-input__prefix {
  left: 10px;
}
</style>
